import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import { __ } from 'i18n-for-browser';

import CaretDown from '../../../assets/img/caret_down.svg';
import PlusIcon from '../../../assets/img/icons/plus_icon.svg';

export default withRouter(class BudgetHeaderDropdown extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    dropdownTitle: PropTypes.string,
    bank: PropTypes.bool
  };
  static defaultProps = {
    active: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleDropdown() {
    this.setState({
      showOverlay: !this.state.showOverlay
    })
  }

  handleClick() {
    if (!this.props.bank) {
      this.toggleDropdown();
    } else {
      const path = this.props.match.url;

      if (path.indexOf('bank') !== -1) {
        this.props.history.goBack();
      } else {
        window.sessionStorage.setItem('prevLocation', this.props.history.path);
        this.props.history.push('/bank');
      }
    }
  }

  render() {
    const { active } = this.props;

    return (
      <div className={'budget-header-dropdown' + (this.state.showOverlay ? ' show' : '')} onClick={this.handleClick}>
        <div className={'budget-header-overlay'}/>
        <div className={'inner-dropdown ' + (active ? 'active-item' : '')}>
          <img className={'icon'} alt={'dropdown-img'} src={this.props.icon}/>
          {this.props.notification ?
            <div className="notification"><span><p>!</p></span></div>
            : null}

          {this.props.doubleTitle ?
            <span className={'doubleTitle'}>{this.props.doubleTitle}</span>
          : ''}
          <p className={'second-title'}>
            &nbsp;&nbsp;
            {this.props.title}
            {this.props.doubleTitle ?
              <span>{__('sim_miljard')}</span>
            : ''}
          </p>

          {
            (this.props.bank)
              ?
              <div className={this.props.match.url.indexOf('bank') !== -1 ? 'dropdown-link bank-active' : 'dropdown-link'}>
                <span>
                  <img alt={'dropdown-plus'} src={PlusIcon}/>
                </span>
              </div>
              :
              <span className={'caret'}>
                <img alt={'dropdown-arrow'} src={CaretDown}/>
              </span>
          }

        </div>

        <div className={'dropdown-content' + (this.state.showOverlay ? ' show' : '')} onClick={(ev) => {ev.stopPropagation()}}>
          <h3>{this.props.dropdownTitle}</h3>
          {this.props.children}
        </div>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/BudgetHeaderDropdown.js